<template>
  <div class="holder">
    <router-view></router-view>

    <div class="navigation" :class="roleClass">

      <div class="breadcrumbs">
        {{$store.getters.rackShelfInfo}}
      </div>
      <div class="filter">
        <div style="display: inline-block; vertical-align: middle; width: 300px;">

          <material-input parentClass="" label="ID или Название"
                          @inputStr="inputStr"
                          v-bind:valueStr="searchStr"
          ></material-input>
        </div>



            <div style="display: inline-block; vertical-align: middle; font-size: 14px; padding-top: 10px">
              <div v-if="$store.state.user.role === 'PM'">
                <label for="onlyNew"><input type="checkbox" id="onlyNew" v-model="onlyAdd"> Только новые</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label for="onlyLost"><input type="checkbox" id="onlyLost" v-model="onlyRemove"> Только ушедшие</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <div v-if="$store.state.user.role === 'HM'">
                <label for="onlyNeedRemoval"><input type="checkbox" id="onlyNeedRemoval" v-model="onlyRemove">
                  Только те, что надо убрать</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label for="onlyNeedPlacement"><input type="checkbox" id="onlyNeedPlacement"
                                                      v-model="onlyAdd">
                  Только те, что еще не расставлены</label>
              </div>
            </div>



      </div>

      <div class="table-holder">

        <table>
          <thead>
          <tr>
            <td class="id">
              ID

            </td>
            <td class="photo">Фото</td>
            <td class="title">
              Название

            </td>
            <td class="group"  v-if="$store.state.user.role === 'HM'">
              Кластер

            </td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="product in productList" :class="{'anti-facing': product.noFacing}">
            <td class="id">{{product.groupId}}</td>
            <td class="photo">
              <div class="photo-item" :style="{'background-image': `url('${product.photos.FRONT}')`}"></div>
            </td>
            <td class="title" v-on:dblclick="add(product)">{{product.title}}
            </td>
            <td class="group" v-if="$store.state.user.role === 'HM'">{{product.cluster ? product.cluster.title : ''}}</td>
          </tr>
          </tbody>

        </table>


        <a href="#"
           ref="next"
           @click.prevent="loadNextPage"
           v-if="next != null"
           class = "more"
        >Еще товары</a>

      </div>

    </div>
    <div class="editor-field" :class="roleClass">

      <shelf v-if="$store.state.user.role === 'HM'"
            :initWidth="800"
            :initHeight="400"
            :initDepth="300"
            :x="0"
            :zoom="2"
            :id="this.$route.params.shelf"
      ></shelf>

      <shelfView v-if="$store.state.user.role !== 'HM'"
             :initWidth="800"
             :initHeight="400"
             :initDepth="300"
             :x="0"
             :zoom="2"
             :id="this.$route.params.shelf"
      ></shelfView>

    </div>


   </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import Vue from 'vue';
import lodash from 'lodash';
import VueLodash from 'vue-lodash/dist/vue-lodash.min';
import axios from 'axios';

import Shelf from './ShelfEditor';
import ShelfView from './ShelfView';


Vue.use(VueLodash, lodash);

export default {
  name: 'hello',
  data() {
    return {
      searchStr: '',
      productList: [],
      currentPage: '/api/products/',
      isLoading: false,
      next: null,
      onlyAdd: false,
      onlyRemove: false,
      isHM: this.$store.state.user.role === 'HM',
      roleClass: this.$store.state.user.role === 'HM' ? 'hm' : 'pm',
    };
  },
  methods: {
    load(clearList) {
      if (this.isHM) {
        this.loadURL(`/api/v2/products/?pharmacy=${this.$route.params.id}&search=${this.searchStr}&onlyAdd=${this.onlyAdd}&onlyRemove=${this.onlyRemove}`, clearList);
      } else {
        this.loadURL(`/api/v2/products/?shelf=${this.$route.params.shelf}&search=${this.searchStr}&onlyAdd=${this.onlyAdd}&onlyRemove=${this.onlyRemove}`, clearList);
      }
    },
    loadURL(url, clearList) {
      const that = this;
      axios.get(url).then((response) => {
        that.isLoading = false;
        that.makeList(response.data, clearList);
      });
    },
    makeList(response, clearList) {
      if (clearList) {
        this.productList = [];
      }
      this.next = response.next;
      if (response.results.length > 0) {
        response.results.forEach((product) => {
          const productCopy = Object.assign({}, product);
          if (product.photos.length > 0) {
            productCopy.photos = Object.assign(...product.photos.map(
              o => ({ [o.side]: o.photo50 }),
            ));
          }
          this.productList.push(productCopy);
        });
      }
    },
    add(product) {
      // eslint-disable-next-line no-undef
      if (this.$store.state.user.role === 'HM') {
        this.$emit('addProduct', product);
      }
    },

    inputStr: Vue._.debounce(function mutated(input) { this.searchStr = input; }, 500),
    runOnScroll() {
      if (this.hasNext) {
        if ((this.$refs.nextLink.offsetParent.scrollTop + window.outerHeight + 150) >
          this.$refs.nextLink.offsetTop) {
          this.loadNextPage();
        }
      }
    },
    loadNextPage() {
      if (!this.isLoading && this.next != null) {
        this.isLoading = true;
        this.loadURL(this.next, false);
      }
    },
  },
  watch: {
    searchStr() {
      this.load(true);
    },
    onlyAdd() {
      this.load(true);
    },
    onlyRemove() {
      this.load(true);
    },
  },
  computed: {
    rackShelfInfo() {
      return this.$store.state.shelf !== null ? `${this.$store.state.shelf.rack.title} / #${this.$store.state.shelf.number}` : '';
    },
  },
  created() {
    const self = this;
    self.load('', true);
    this.$parent.$on('save', () => {
      self.$emit('save');
    });
  },
  components: { Shelf, ShelfView },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">


  .breadcrumbs {
    font-size: 20px;
    margin: 0 20px;
  }

  .navigation{
    width: 630px;

    &.pm{
        width: 400px;
     }
  }

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}


.editor-field{
  overflow: hidden;
  left: 630px;

  &.pm{
    left: 430px;
  }
}

.table-holder{
  overflow-y: scroll;
  position: absolute;
  top: 110px;
  left: 20px;
  right: 0;
  bottom: 0;
}

.filter{
  margin: 20px;
}


table, td{
  padding: 0;
  margin: 0;
  border-collapse: collapse;
  border-spacing: 0;
  vertical-align: top;
  font-size: 12px;
  line-height: 16px;
  box-sizing: border-box;
}

thead td{
  text-align: left;
  height: 60px;
  background: #FFFFFF;
  border-bottom: 2px solid #eaeaea;
  vertical-align: middle;
}

td{
  padding: 15px 10px;
  height: 44px;
  vertical-align: top;
  text-align: left;
  font-family: 'Roboto', sans-serif;
  border-top:1px solid #eaeaea;
}

tbody td{
  /*padding: 15px 10px 0;*/
}

.anti-facing td{
  background: rgba(254,223,229,0.4);
  border-top-color:#EBEEF0;
}

.id{
  width: 60px;
  border-left:1px solid #eaeaea;
}

.photo{
  width: 45px;
}
  .photo-item{
    width: 40px;
    height: 40px;
    background: #FFFFFF center no-repeat;
    text-align: center;
    background-size: contain;
  }


.title{
  width: 250px;
}

.group{
  width: 145px;
  border-right:1px solid #eaeaea;
}

.notInOrder{
  width: 70px;
}


.cats{
  background: #fcfcfc;
  min-width: 40px;
  border-right: 1px solid #eaeaea;
}

.sort-arrow{
  color:#ccc;
}

  .more{
    color: #42b983;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// Shelf.vue?2156a7e8